
// @flow

import deepcopy from "deepcopy";


const initialState = {
    cartItems:[],
    isLoading: false,
    selectedQuantity:1,
    cartItemCopy:[],
    cartAmount : 0,
    totalShipping:0,
    retailPrice:0,
    paymentHashKey:"",
};

export default function pay(state= initialState, action:any) {
    switch (action.type) {
        case 'CART_PENDING':
            return {...state, isLoading:true,cartAmount : 0};
        case 'CART_FULFILLED':
            return {
                ...state,paymentHashKey : action.payload.data.PaymentHash,
                cartItems:action.payload.data.cartList,
                cartItemCopy:action.payload.data.cartList, 
                cartAmount:action.payload.data.TotalAmount, 
                totalShipping:action.payload.data.TotalShipping, 
                isLoading:false,
            };
        case 'CART_REJECTED':
            return {...state,isLoading:false,cartItems:[]};
        case 'CLEAR_CART':
            return {...state,cartItems:[], cartAmount:0 ,totalShipping:0};
        case 'SHOW_HIDE_DETAIL':
            var cartItems = JSON.parse(JSON.stringify(state.cartItems ));
            cartItems[action.index].hideDetail = !cartItems[action.index].hideDetail
            return {...state, cartItems};
        case 'INCREASE_QUANTITY':
            var cardItem = action.item;
            const index = action.index;
            var cartList = deepcopy(state.cartItems)
            var totalAmount =  deepcopy(state.cartAmount)
            if(cardItem.AdKey == cartList[index].AdKey && cardItem.QuantityLimit > cardItem.SelectedQuantity){
                    cartList[index].SelectedQuantity  = cartList[index].SelectedQuantity + 1 ;
                    cartList[index].MRP  = cartList[index].MRP + state.cartItemCopy[index].OriginalMRP ;
                    cartList[index].RetailPrice  = cartList[index].RetailPrice + state.cartItemCopy[index].OriginalRetailPrice ; 
                    totalAmount = totalAmount + state.cartItemCopy[index].OriginalRetailPrice;
                    cartList[index].DisplayReward = cartList[index].DisplayReward + cardItem.Reward;
            }
            return {...state,cartItems:cartList,cartAmount:totalAmount};   
        case 'DECREASE_QUANTITY':
            var cardItem = action.item;
            const indx = action.index;
            var cartList = deepcopy(state.cartItems)
            var totalAmount =  deepcopy(state.cartAmount)
                if(cardItem.AdKey == cartList[indx].AdKey && cardItem.SelectedQuantity > 1){
                    cartList[indx].SelectedQuantity  = cartList[indx].SelectedQuantity - 1;
                    cartList[indx].MRP  = cartList[indx].MRP - state.cartItemCopy[indx].OriginalMRP ;
                    cartList[indx].RetailPrice  = cartList[indx].RetailPrice - state.cartItemCopy[indx].OriginalRetailPrice ; 
                    totalAmount = totalAmount - state.cartItemCopy[indx].OriginalRetailPrice;
                    cartList[indx].DisplayReward = cartList[indx].DisplayReward - cardItem.Reward;
                }
            
            return {...state,cartItems:cartList,cartAmount:totalAmount};  
        case 'REMOVE_ITEM_FROM_CART_PENDING':
            return { ...state, isLoading:true};
        case 'REMOVE_ITEM_FROM_CART_FULFILLED':
            return { ...state, 
                cartItemCopy:action.payload.data.cartList, 
                cartItems:action.payload.data.cartList, 
                cartAmount:action.payload.data.TotalAmount, 
                totalShipping:action.payload.data.TotalShipping, 
                isLoading:false };
        case 'REMOVE_ITEM_FROM_CART_REJECTED':
            return { ...state, isLoading:false };
        case 'UPDATE_ADD_TO_CART_PENDING':
            return { ...state, isLoading:true };
        case 'UPDATE_ADD_TO_CART_FULFILLED':
            return { ...state,isLoading:false };
        case 'UPDATE_ADD_TO_CART_REJECTED':
            return { ...state, isLoading:false };
        case 'RETAIL_PRICE':
            return {...state,retailPrice:deepcopy(action.payload)}; 
        case 'LOG_OUT':
            return state;
        default:
            return state;
    }
}
